import script from "./PayrollTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PayrollTable.vue?vue&type=script&setup=true&lang=js"

import "./PayrollTable.vue?vue&type=style&index=0&id=215413b0&lang=css"

const __exports__ = script;

export default __exports__